import { FC, PropsWithChildren, createContext, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { AsyncBoundary, useSuspense } from '@data-client/react'

import classNames from 'classnames'

import { Spinner } from '../components/loader'
import { Result } from '../components/result'
import defaultConfig from '../configs'
import { ConfigResource, PageConfig, PortalConfig } from '../datasource/config'

const Context = createContext<PortalConfig>(defaultConfig)

// const theme = {
//   '@accent-color': '#fdf6e4',
//   '@alert-error-bg-color': 'var(--error-color)',
//   '@alert-error-border-color': 'var(--error-color)',
//   '@alert-error-icon-color': '#ffffff',
//   '@alert-error-message-color': '#ffffff',
//   '@alert-info-bg-color': '#fff6e8',
//   '@alert-info-border-color': '#fff6e8',
//   '@alert-info-icon-color': '#cf8516',
//   '@alert-info-message-color': '#cf8516',
//   '@alert-message-color': 'var(--text-color)',
//   '@alert-success-bg-color': 'rgb(206, 238, 227)',
//   '@alert-success-border-color': 'rgb(206, 238, 227)',
//   '@alert-success-icon-color': 'rgb(21, 69, 47)',
//   '@alert-success-message-color': 'rgb(21, 69, 47)',
//   '@alert-warning-bg-color': 'var(--warning-color)',
//   '@alert-warning-border-color': 'var(--warning-color)',
//   '@alert-warning-icon-color': 'var(--warning-color)',
//   '@alert-warning-message-color': 'var(--warning-color)',
//   '@alert-with-description-icon-size': '24px',
//   '@avatar-bg': '#000',
//   '@avatar-color': 'var(--text-color)',
//   '@background-color-base': '#ffffff',
//   '@badge-color': 'var(--primary-color)',
//   '@badge-count-bg': 'var(--primary-color)',
//   '@badge-count-color': 'var(--text-color-inverse)',
//   '@badge-font-family': 'var(--font-family-primary)',
//   '@badge-font-size': '14px',
//   '@body-background': '#fffdf9',
//   '@border-color-base': '#e8e7e9',
//   '@border-color-focused': '#868690',
//   '@border-color-inverse': '#ffffff',
//   '@border-radius-base': '4px',
//   '@border-radius-lg': '16px',
//   '@border-radius-md': '8px',
//   '@border-radius-sm': '4px',
//   '@border-radius-xs': '2px',
//   '@border-style-base': 'solid',
//   '@border-width-base': '1px',
//   '@breadcrumb-base-color': 'rgb(159, 158, 166)',
//   '@breadcrumb-font-family': 'var(--font-family-secondary)',
//   '@breadcrumb-font-size': '12px',
//   '@breadcrumb-last-item-color': 'rgb(110, 109, 121)',
//   '@breadcrumb-link-color': 'rgb(159, 158, 166)',
//   '@breadcrumb-link-color-hover': 'var(--text-color-secondary)',
//   '@breadcrumb-separator-color': 'rgb(159, 158, 166)',
//   '@btn-border-radius': '4px',
//   '@btn-default-bg': '#2a6449',
//   '@btn-default-border': '#2a6449',
//   '@btn-default-color': '#ffffff',
//   '@btn-default-disabled-color': 'rgb(255, 255, 255)',
//   '@btn-default-hover-bg': 'rgb(159, 158, 166)',
//   '@btn-default-hover-border': 'rgb(159, 158, 166)',
//   '@btn-default-hover-color': 'var(--text-color-secondary)',
//   '@btn-disable-bg': 'rgb(248, 248, 248)',
//   '@btn-disable-border': '#e8e7e9',
//   '@btn-disable-color': 'rgb(183, 183, 189)',
//   '@btn-font-family': 'var(--font-secondary-primary)',
//   '@btn-font-size': 'var(--font-size-base)',
//   '@btn-font-size-lg': '14px',
//   '@btn-font-weight': '700',
//   '@btn-ghost-bg': 'transparent',
//   '@btn-ghost-border': '#e8e7e9',
//   '@btn-ghost-color': 'var(--text-color-secondary)',
//   '@btn-ghost-hover-bg': 'transparent',
//   '@btn-ghost-hover-border': '#e8e7e9',
//   '@btn-ghost-hover-color': 'var(--text-color-secondary)',
//   '@btn-height-base': '48px',
//   '@btn-height-lg': '48px',
//   '@btn-primary-bg': '#fffdf9',
//   '@btn-primary-border-color': '#2a6449',
//   '@btn-primary-color': '#2a6449',
//   '@btn-primary-hover-bg': '#2a6449',
//   '@btn-primary-hover-border-color': '#2a6449',
//   '@btn-primary-hover-color': '#ffffff',
//   '@btn-square-only-icon-size': '16px',
//   '@btn-text-transform': 'uppercase',
//   '@calendar-item-active-bg': '#57806e',
//   '@card-badge-bg': 'var(--primary-color)',
//   '@card-badge-color': 'var(--text-color-inverse)',
//   '@card-bg': '#fffdfa',
//   '@card-blur-bg-transparency': '0.75',
//   '@card-hoverable-hover-border': '#e8e7e9',
//   '@card-hoverable-hover-shadow': '0px 0px 31px rgba(0, 0, 0, 0.06)',
//   '@card-meta-font-family': 'var(--font-family-secondary)',
//   '@card-selected-bg': 'rgb(248, 248, 248)',
//   '@card-shadow': '0 0 1px rgb(207, 207, 211)',
//   '@card-subtitle-font-family': 'var(--font-family-secondary)',
//   '@cart-icon-bg': '#212224',
//   '@cart-icon-color': '#ffffff',
//   '@checkbox-bg': 'var(--input-bg)',
//   '@checkbox-border-width': '1px',
//   '@checkbox-check-bg': 'var(--text-color)',
//   '@checkbox-check-color': 'var(--text-color-inverse)',
//   '@checkbox-color': 'var(--text-color)',
//   '@checkbox-size': '16px',
//   '@collapse-body-bg': '#ffffff',
//   '@collapse-body-color': 'var(--text-color)',
//   '@collapse-header-bg': 'var(--card-bg)',
//   '@collapse-header-color': 'var(--text-color)',
//   '@component-background': '#ffffff',
//   '@component-color': 'var(--text-color-secondary)',
//   '@danger-color': '#d2381b',
//   '@date-picker-bg': 'var(--input-bg)',
//   '@date-picker-cell-color': 'var(--text-color)',
//   '@date-picker-heading-color': 'var(--text-color-secondary)',
//   '@disabled-color': '#cfcfd3',
//   '@drawer-bg': 'var(--body-background)',
//   '@drawer-body-padding': '40px',
//   '@drawer-header-close-bg': '#ffffff',
//   '@drawer-header-close-color': 'var(--text-color)',
//   '@drawer-header-close-hover-bg': '#ffffff',
//   '@drawer-header-close-hover-color': 'var(--text-color)',
//   '@drawer-header-close-size': '48px',
//   '@error-color': '#e06c51',
//   '@font-family-primary': "'Playfair Display', serif",
//   '@font-family-secondary': "'Open Sans', sans-serif",
//   '@font-family-tertiary': "'Open Sans', sans-serif",
//   '@font-size-base': '14px',
//   '@font-size-lg': '14px',
//   '@font-size-sm': '12px',
//   '@font-weight-base': '400',
//   '@font-weight-strong': '700',
//   '@form-item-label-font-size': '12px',
//   '@heading-1-size': '28px',
//   '@heading-2-size': '24px',
//   '@heading-3-size': '22px',
//   '@heading-4-size': '20px',
//   '@heading-5-size': '18px',
//   '@heading-color': '#2a6449',
//   '@heading-font-family': "'Playfair Display', serif",
//   '@heading-font-weight': '500',
//   '@heading-secondary-color': '#2a6449',
//   '@heading-secondary-font-family': "'Playfair Display', serif",
//   '@heading-secondary-font-weight': '500',
//   '@heading-transform': 'uppercase',
//   '@height-base': '48px',
//   '@height-lg': '48px',
//   '@icon-color': 'inherit',
//   '@info-color': '#2db7f5',
//   '@input-bg': '#ffffff',
//   '@input-border-color': '#a0a0a0',
//   '@input-border-radius': '4px',
//   '@input-color': 'var(--text-color)',
//   '@input-disabled-bg': '#f8f8f8',
//   '@input-disabled-color': 'var(--text-color-secondary)',
//   '@input-height-base': '48px',
//   '@input-height-lg': '48px',
//   '@input-height-sm': '36px',
//   '@input-hover-border-color': 'rgb(85, 85, 94)',
//   '@input-icon-color': 'var(--text-color)',
//   '@input-label-color': 'var(--input-color)',
//   '@input-number-handler-bg': '#ffffff',
//   '@label-color': 'var(--text-color-secondary)',
//   '@layout-body-background': '#ffffff',
//   '@layout-footer-background': 'transparent',
//   '@layout-footer-height': '112px',
//   '@layout-footer-padding': '40px',
//   '@layout-header-background': 'transparent',
//   '@layout-header-border-color': '#e8e7e9',
//   '@layout-header-color': 'var(--text-color)',
//   '@layout-header-height': '112px',
//   '@layout-header-mobile-height': '80px',
//   '@layout-header-padding': '48px 40px 24px 40px',
//   '@layout-section-padding': '40px',
//   '@layout-section-padding-horizontal': '40px',
//   '@layout-section-padding-vertical': '40px',
//   '@layout-section-title-font-family': 'var(--font-family-primary)',
//   '@layout-sider-background': 'var(--text-color)',
//   '@layout-sider-collapsed-width': '112px',
//   '@layout-sider-width': '280px',
//   '@link-active-color': 'var(--primary-color)',
//   '@link-color': 'var(--primary-color)',
//   '@link-decoration': 'none',
//   '@link-hover-color': 'var(--primary-color)',
//   '@link-hover-decoration': 'underline',
//   '@list-item-active-bg': '#e9e9e9',
//   '@list-item-active-color': 'var(--text-color)',
//   '@list-item-bg': '#ffffff',
//   '@list-item-color': 'var(--text-color)',
//   '@list-item-hover-bg': '#f0f0f0',
//   '@list-item-hover-color': 'var(--text-color)',
//   '@list-item-meta-description-color': 'var(--text-color-secondary)',
//   '@list-item-meta-description-font-family': 'var(--font-family-secondary)',
//   '@list-item-meta-description-font-size': '1em',
//   '@list-item-meta-title-color': 'var(--text-color-secondary)',
//   '@list-item-meta-title-font-family': 'var(--font-family-secondary)',
//   '@menu-bg': '#fffdf9',
//   '@menu-collapsed-width': '112px',
//   '@menu-dark-bg': 'transparent',
//   '@menu-dark-color': 'var(--text-color-inverse)',
//   '@menu-dark-highlight-color': 'var(--menu-highlight-color)',
//   '@menu-dark-item-active-bg': 'transparent',
//   '@menu-dark-selected-item-icon-color': 'var(--menu-highlight-color)',
//   '@menu-dark-selected-item-text-color': 'var(--text-color-inverse)',
//   '@menu-highlight-color': 'var(--primary-color)',
//   '@menu-icon-margin-right': '16px',
//   '@menu-icon-size': '16px',
//   '@menu-icon-size-lg': '24px',
//   '@menu-item-active-bg': 'var(--primary-color)',
//   '@menu-item-active-color': '#fffdf9',
//   '@menu-item-color': '#2a6449',
//   '@menu-item-font-family': 'var(--font-secondary-primary)',
//   '@menu-item-font-size': '15px',
//   '@menu-item-font-weight': '500',
//   '@menu-item-height': '48px',
//   '@menu-item-hover-bg': 'transparent',
//   '@menu-item-hover-color': 'var(--primary-color)',
//   '@menu-item-padding': '48px / 2 40px',
//   '@menu-item-text-transform': 'uppercase',
//   '@menu-item-vertical-margin': '8px',
//   '@modal-bg': '#ffffff',
//   '@modal-close-color': '#212224',
//   '@modal-footer-bg': '#ffffff',
//   '@notification-width': '420px',
//   '@outline-blur-size': '0',
//   '@outline-width': '0',
//   '@page-header-back-color': '#000',
//   '@page-header-heading-font-family': 'var(--font-family-primary)',
//   '@page-header-heading-font-weight': '500',
//   '@page-header-heading-title': '36px',
//   '@page-header-padding': '0',
//   '@page-header-padding-breadcrumb': '0',
//   '@page-header-padding-vertical': '0',
//   '@pagination-item-size': '36px',
//   '@picker-basic-cell-active-with-range-color': 'rgba(206, 238, 227, 0.3)',
//   '@picker-panel-cell-height': '40px',
//   '@picker-panel-cell-width': '40px',
//   '@popover-bg': '#ffffff',
//   '@primary-color': '#2a6449',
//   '@radio-border-width': '1px',
//   '@radio-button-bg': 'var(--text-color-inverse)',
//   '@radio-button-checked-bg': 'var(--text-color-inverse)',
//   '@radio-button-color': 'var(--text-color-inverse)',
//   '@radio-dot-color': '#212224',
//   '@radio-size': '16px',
//   '@success-color': '#ceeee3',
//   '@table-bg': 'var(--component-background)',
//   '@table-border-color': '#e8e7e9',
//   '@table-expand-icon-bg': 'rgb(207, 207, 211)',
//   '@table-expand-icon-color': 'white',
//   '@table-header-bg': '#f8f8f8',
//   '@table-header-color': 'var(--text-color)',
//   '@table-header-selected-bg': '#e4e4e4',
//   '@table-header-selected-color': 'var(--text-color)',
//   '@table-row-bg': 'var(--body-background)',
//   '@table-row-color': 'var(--text-color)',
//   '@table-row-hover-bg': 'rgb(248, 248, 248)',
//   '@table-row-hover-color': 'var(--text-color)',
//   '@tabs-active-color': 'var(--primary-color)',
//   '@tabs-font-family': 'var(--font-family-secondary)',
//   '@tabs-font-size': 'var(--font-size-base)',
//   '@tag-default-bg': '#e7e9e8',
//   '@tag-default-color': 'var(--text-color-secondary)',
//   '@tag-font-family': 'var(--font-family-secondary)',
//   '@tag-font-size': '11px',
//   '@text-color': '#212224',
//   '@text-color-inverse': '#ffffff',
//   '@text-color-secondary': '#6e6d79',
//   '@text-selection-bg': 'var(--text-color)',
//   '@toast-error-bg': 'var(--error-color)',
//   '@toast-error-icon-color': '#ffffff',
//   '@toast-error-message-color': '#ffffff',
//   '@toast-error-title-color': '#ffffff',
//   '@toast-info-bg': '#fff6e8',
//   '@toast-info-icon-color': '#cf8516',
//   '@toast-info-message-color': '#cf8516',
//   '@toast-info-title-color': '#cf8516',
//   '@toast-success-bg': 'rgb(206, 238, 227)',
//   '@toast-success-icon-color': 'rgb(21, 69, 47)',
//   '@toast-success-message-color': 'rgb(21, 69, 47)',
//   '@toast-success-title-color': 'rgb(21, 69, 47)',
//   '@toast-warning-bg': 'var(--warning-color)',
//   '@toast-warning-icon-color': 'var(--text-color-inverse)',
//   '@toast-warning-message-color': 'var(--text-color-inverse)',
//   '@toast-warning-title-color': 'var(--text-color-inverse)',
//   '@tooltip-arrow-color': 'var(--primary-color)',
//   '@tooltip-bg': 'var(--primary-color)',
//   '@tooltip-color': '#ffffff',
//   '@typography-title-font-weight': '800',
//   '@warning-color': '#fce3a4',
//   '@white': '#ffffff',
// }
const theme = {}
const Provider: FC<PropsWithChildren> = ({ children }) => {
  // Possibly pulling config from local storage to run dev mode (switching between portals)
  // const config = ls.get<PortalConfig>('pv.dev.config')
  const data = useSuspense(ConfigResource.handshake)
  if (!data) return <Result.ConfigurationError />
  return <Context.Provider value={PortalConfig.fromJS(data)}>{children}</Context.Provider>
}

export const useConfig = () => useContext(Context)

export type IntlFormatter = {
  currency: {
    (value: number): string
    (value: number | bigint): string
  }
  message: (id: string, defaultMessage: string) => string
}

export const useIntlFormatter: () => IntlFormatter = () => {
  const { formatMessage, formatNumber } = useIntl()
  const {
    intl: { currency },
  } = useConfig()
  return {
    currency: (value: number | bigint) => formatNumber(value, { format: 'money', currency: currency }),
    message: (id: string, defaultMessage: string) => formatMessage({ id, defaultMessage: defaultMessage }),
  }
}

type MenuConfigProps = {
  pages: PageConfig[]
  pageByUri: (uri: string, getBase?: boolean) => PageConfig | undefined
  pageNameByUri: (uri: string, fallback?: string) => string
}

export const useMenuConfig: () => MenuConfigProps = () => {
  const portal = useConfig()
  const pages = useMemo(
    () => portal.pages.filter((page) => page.enabled).sort((a, b) => a.order - b.order),
    [portal.pages],
  )

  function pageByUri(uri = '', getBase = false) {
    let pathname = uri
    if (getBase) {
      pathname = (uri.startsWith('/') ? uri.slice(1) : uri).split('/')[0]
    }
    pathname = !pathname.startsWith('/') ? `/${pathname}` : pathname
    return pages.find((it) => it.uri === `${pathname}`)
  }

  const pageNameByUri = (uri = '', fallback?: string) => pageByUri(uri)?.name ?? fallback ?? ''
  return { pages, pageNameByUri, pageByUri }
}

export const withPrefix: (...names: string[]) => string = (...names) => {
  const key = 'pv'
  return classNames(
    names.filter((value) => !!value.trim()).map((name) => (!name.startsWith(key) ? `${key}-${name} ` : name)),
  ).trim()
}

const ConfigProvider: FC<PropsWithChildren> = ({ children }) => (
  <AsyncBoundary fallback={<Spinner fullscreen />}>
    <Provider>{children}</Provider>
  </AsyncBoundary>
)
export { ConfigProvider, Context }
